import * as React from 'react';

import {Relationship} from 'shells/entity/entity-display-values/relationship/relationship';

type Props = {
    name: string;
    value: any[];
};

export function CellHierarchy(props: Props) {
    const value = props.value.map((v) => v.value);

    return <Relationship name={props.name} value={value} />;
}
